{
  "titles": {
    "tasks": "Acties"
  },
  "messages": {
    "emptyStateTitle": "Geen acties",
    "emptyStateDescription": "Op dit moment zijn er geen acties. Zodra er een actie beschikbaar is, wordt deze hier automatisch weergegeven."
  },
  "taskTitles": {
    "FundingContractSend": "Contract verzenden",
    "FundingContractEnding": "Contract verlengen",
    "PaymentBatchApproval": "Uitbetalingen accorderen",
    "FundingContractValidationsCheck": "Contract voorwaardes controleren",
    "FundingContractBookReimbursement": "Gelden terugbetalen",
    "FundingContractDeviationProposalRejected": "Afwijking afgekeurd",
    "FundingContractDeviationProposalRejected-interestRate": "Afwijkende rente afgekeurd",
    "FundingContractDeviationProposalRejected-durationInMonths": "Afwijkende looptijd afgekeurd"
  },
  "taskSubtitles": {
    "PaymentBatchApproval": "Via twikey"
  }
}
